module.exports = __webpack_public_path__ + "images/signature-1924fe12507f36cd902c0776ea738125.png";